export default "__VITE_ASSET__e482621d__"